/* eslint-disable react-hooks/exhaustive-deps */
import { ApexOptions } from "apexcharts";
import { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { DateRangePicker, Loader } from "rsuite";
import peticionBack from "../../../libs/peticiones/peticionBack";
import createURL from "../../../libs/peticiones/url";
import CardC from "../../../components/CustomCard/CardC";

type Dato = {
    total: number;
    zone: string;
    zone_id: string;
};
type Zone = {
    y: number;
    x: string;
    id: string;
};

const defConfig = {
    options: {
        chart: {
            type: "bar",
            events: {
                dataPointSelection: (_e, _chart, _config) => {},
            },
        },
        xaxis: {
            categories: [],
        },
        plotOptions: {
            bar: {
                columnWidth: "50%",
                distributed: true,
                dataLabels: {
                    position: "top",
                },
            },
        },
        dataLabels: {
            enabled: true,
            offsetY: -20,
            style: {
                fontSize: "12px",
                colors: ["#19165F"],
            },
        },
        legend: {
            show: false,
        },
        series: [],
    } as ApexOptions,
    series: [] as any[],
};

export default function ZoneChart({ district, region, setHook }: { district?: Zone; region?: Zone; setHook?: Function }) {
    const [dates, setDates] = useState<Date[] | null>(null);
    const [config, setConfig] = useState(defConfig);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getData();
    }, [dates, district, region]);

    async function getData() {
        let url = createURL("/reportes/files/count/zone", [
            { name: "startDate", value: cleanDate(0) },
            { name: "endDate", value: cleanDate(1) },
            { name: "region", value: region?.id || "" },
            { name: "district", value: district?.id || "" },
        ]);
        const cpy = { ...defConfig };
        if (cpy.options.chart) {
            cpy.options.chart.events = {
                dataPointSelection: (_e, _c, config) => {
                    if (setHook) setHook(config.w.config.series[0].data[config.dataPointIndex]);
                },
            };
        }
        setLoading(true);
        const res = await peticionBack({}, url, "GET", false);
        if (res && res.length > 0) {
            const names: string[] = [],
                values: any[] = [];
            res.sort((a: Dato, b: Dato) => a.zone.localeCompare(b.zone)).forEach((d: Dato) => {
                names.push(d.zone);
                values.push({ x: d.zone, y: d.total, id: d.zone_id });
            });
            cpy.series = [{ name: "total", data: values }];
            cpy.options.xaxis = {
                type: "category",
                categories: names,
                labels: { show: true },
            };
        } else {
            cpy.series = [];
        }
        setConfig(cpy);
        setLoading(false);
    }

    function cleanDate(pos: number) {
        if (!dates) return "";
        let str = dates[pos].toISOString().split("T")[0];
        if (pos === 0) str += "T00:00:00Z";
        else str += "T23:59:59Z";
        return str;
    }

    function getTile() {
        let tt = "Sentencias por ";
        if (district) {
            tt += "Jusgados del distrito " + district?.x;
        } else if (region) {
            tt += "Distritos de la región " + region?.x;
        } else tt += "Regiones";
        return tt;
    }

    return (
        <CardC className="mb-4">
            <div className="d-flex flex-md-row flex-column justify-content-md-between mb-2">
                <h6>{getTile()}</h6>
                <DateRangePicker size="xs" appearance="subtle" placeholder="Fechas" style={{ width: "auto" }} onChange={(e) => setDates(e)} preventOverflow placement="auto" />
            </div>
            <div className="border">
                {loading ? (
                    <div className="text-center py-auto" style={{ minHeight: "315px" }}>
                        <Loader center size="md" />
                    </div>
                ) : (
                    <Chart options={config.options} series={config.series} type="bar" height={300} />
                )}
            </div>
        </CardC>
    );
}
